import Icon from 'Components/Icon';
import React from 'react';

const Circle = props => <Icon icon={['fas', 'circle']} size={props.size || 'xs'} color={props.color} {...props}/>;

export default Circle;
